import { hardenTimeout } from '@wix/client-security'

export const overrideTimeout = hardenTimeout
